export default __webpack_public_path__ + "static/media/gitlab.9958062d.svg";